import { render, staticRenderFns } from "./SrNotification.vue?vue&type=template&id=6f9cd5c6"
import script from "./SrNotification.vue?vue&type=script&lang=js"
export * from "./SrNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports